export function hasTouchSupport(): boolean {
    if (!window || !navigator) return false;

    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}